// extracted by mini-css-extract-plugin
export default {"hero_main_container":"Hero_hero_main_container__SEB8z","hero_heading":"Hero_hero_heading__MnRRH","hero_text":"Hero_hero_text__kCcIT"};